import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { translate } from 'translations/translator';
import ModalsTranslationVariant from 'translations/variants/modals';
const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

export const NoAssignmentModal = ({ onClose }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box>
        <Typography variant="h6">
          {getTranslation(ModalsTranslationVariant.noActivitiesInAssignment)}
        </Typography>
      </Box>
      <Typography variant="body1">
        {getTranslation(ModalsTranslationVariant.noAssignmentDetails)}
      </Typography>
      <Box className={classes.actionItem}>
        <HwtButton variant="contained" onClick={onClose}>
          <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px', fontSize: '14px' }} />
          {getTranslation(ModalsTranslationVariant.addActivity)}
        </HwtButton>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex !important',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '233px',
    width: '616px',
    backgroundColor: '#fff',
    padding: '10px 25px'
  },
  actionItem: {
    alignSelf: 'flex-end'
  }
}));
